/**
 * Emit hosts for the `form-fill` analytics group — 4 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { trackScreenViewed } from '@heidi/analytics/events';
import { ScreenName } from '@heidi/analytics/vocabulary';

export function trackFormLibraryViewed() {
  trackScreenViewed({
    screen_name: ScreenName.FormLibrary,
  });
}
